import { render, staticRenderFns } from "./MtrComponentGroup.vue?vue&type=template&id=687e9bac&scoped=true"
import script from "./MtrComponentGroup.vue?vue&type=script&lang=js"
export * from "./MtrComponentGroup.vue?vue&type=script&lang=js"
import style0 from "./MtrComponentGroup.vue?vue&type=style&index=0&id=687e9bac&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687e9bac",
  null
  
)

export default component.exports